import { render, staticRenderFns } from "./IndicatorComposition.vue?vue&type=template&id=f6309ae0&scoped=true"
import script from "./IndicatorComposition.vue?vue&type=script&lang=js"
export * from "./IndicatorComposition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6309ae0",
  null
  
)

export default component.exports